// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

import { validateUgandaPhoneNumber } from './uganda-phone-number';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'ugandaPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_uganda_phone_number') && validateUgandaPhoneNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
